import 'react-app-polyfill/stable'
import 'core-js'
import React from 'react'
import { createRoot } from 'react-dom/client'
import { ClerkProvider, useAuth, useClerk } from '@clerk/react'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { Provider } from 'react-redux'
import { store } from './redux/Store'
import useMountEffect from './hooks/useMountEffect'
import { clearClerkSessionAccessors, setClerkSessionAccessors } from './services/clerkSession'

const clerkPublishableKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY || ''

function ClerkSessionBridge() {
  const { getToken } = useAuth()
  const { signOut } = useClerk()

  useMountEffect(() => {
    setClerkSessionAccessors({
      getToken: () => getToken(),
      signOut: () => signOut(),
    })

    return clearClerkSessionAccessors
  })

  return null
}

createRoot(document.getElementById('root')).render(
  <ClerkProvider publishableKey={clerkPublishableKey} afterSignOutUrl="/login">
    <Provider store={store}>
      <ClerkSessionBridge />
      <App />
    </Provider>
  </ClerkProvider>,
)

reportWebVitals()
